// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"448":"10f57f5a28c3bb35","735":"4be63a2b82bd420c","911":"afc2ec340b738253"}[chunkId] + ".js";
};